/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timer_StopInputs */

const en_timer_stop = /** @type {(inputs: Timer_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stop timer`)
};

const de_timer_stop = /** @type {(inputs: Timer_StopInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timer stoppen`)
};

/**
* | output |
* | --- |
* | "Stop timer" |
*
* @param {Timer_StopInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const timer_stop = /** @type {((inputs?: Timer_StopInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timer_StopInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_timer_stop(inputs)
	return en_timer_stop(inputs)
});